import { render, staticRenderFns } from "./unit-color-select.vue?vue&type=template&id=798d9465&"
import script from "./unit-color-select.vue?vue&type=script&lang=js&"
export * from "./unit-color-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports